import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal, Button, FormGroup, FormControl, HelpBlock } from 'react-bootstrap';

export default class DuplicateCampaignDialog extends Component {
  getInitialState = () => ({
    name: '',
    error: null,
    showError: false,
  });

  state = this.getInitialState();

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { show } = nextProps;

    if (!show) {
      this.setState(this.getInitialState());
    }
  }

  onChange = event => {
    const { showError } = this.state;

    this.setState({ name: event.target.value });

    if (showError) {
      this.validate(event.target.value);
    }
  };

  duplicate = () => {
    const { onSuccess } = this.props;
    const { name } = this.state;

    if (this.validate()) {
      onSuccess(name);
    }
  };

  errorClass = error => (error ? 'error' : null);

  validate = value => {
    const { name: stateName } = this.state;
    const name = value || stateName;
    let error = null;

    if (!name.trim()) {
      error = 'This field cannot be empty.';
    } else if (!this.isUniqueName(name)) {
      error = 'This name is already in use.';
    }

    this.setState({ showError: true, error });

    return !error;
  };

  isUniqueName = name => {
    const { campaigns } = this.props;

    return !campaigns.some(item => {
      const itemName = item.name.toLowerCase().trim();
      const newName = name.toLowerCase().trim();

      return itemName === newName;
    });
  };

  render() {
    const { campaign, show, onHide } = this.props;
    const { name, error } = this.state;

    return (
      <Modal dialogClassName="campaign-dialog" backdrop="static" show={show} onHide={onHide}>
        <Modal.Header>
          <Modal.Title data-test="modal-duplicatecampaign-title">Duplicate Campaign</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            Duplicate <b>{campaign.name}</b>. Enter a name for the new Campaign.
          </p>
          <FormGroup validationState={this.errorClass(error)}>
            <FormControl
              name="name"
              data-test="modal-duplicatecampaign-input-name"
              placeholder="Enter a name"
              onChange={this.onChange}
              value={name}
              autoFocus
            />
            <HelpBlock>{error}</HelpBlock>
          </FormGroup>
        </Modal.Body>
        <Modal.Footer>
          <Button className="btn-cancel" onClick={onHide}>
            Cancel
          </Button>
          <Button
            data-test="modal-duplicatecampaign-button-duplicate"
            className="btn-add"
            bsStyle="primary"
            onClick={this.duplicate}
          >
            Duplicate Campaign
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

DuplicateCampaignDialog.propTypes = {
  campaigns: PropTypes.array,
  campaign: PropTypes.object.isRequired,
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
};
